import React, { useRef } from 'react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import { IonItem, IonList, IonRadio, IonRadioGroup, RadioGroupChangeEventDetail } from '@ionic/react';
import { IonRadioGroupCustomEvent } from '@ionic/core';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';
import useLanguage from '../../../../hooks/localization/useLanguage';
import { AvailableLanguageInterface } from '../../../../services/exports/Interfaces';
import classnames from 'classnames';
import Button from '../../components/buttons/Button';

const LanguageSwitcherModal = ({ goBack, closeModal }: IModal) => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Modals:LanguageSwitcher:LanguageSwitcherModal',
  });
  const { language, languages, changeLanguage } = useLanguage();

  const selectedLanguage = useRef(language);
  const onChangeLanguage = (event: IonRadioGroupCustomEvent<RadioGroupChangeEventDetail>) => {
    selectedLanguage.current = event.detail.value;
  };

  const onSaveClick = async () => {
    await changeLanguage(selectedLanguage.current);

    goBack();
  };

  return (
    <>
      <ModalWrapper className="mt-4">
        <ModalHeader title={t('title')} onBack={goBack} onClose={closeModal} />
        <section className="space-y-16 py-md">
          <IonList className="pr-md">
            <IonRadioGroup onIonChange={onChangeLanguage} value={selectedLanguage.current}>
              {languages.map((item: AvailableLanguageInterface) => (
                <IonItem key={item.language}>
                  <IonRadio
                    className={classnames(
                      '[&::part(container)]:border-solid [&::part(container)]:border-mobile-secondary [&::part(container)]:border-xs [&::part(container)]:rounded-full [&::part(container)]:size-4 [&::part(mark)]:size-3 aria-checked:[&::part(mark)]:bg-brand-primary [&::part(mark)]:rounded-full [&::part(mark)]:border-none',
                    )}
                    value={item.language}
                    labelPlacement="end"
                    justify="start"
                    aria-label={item.languageName}
                  >
                    {item.languageName}
                  </IonRadio>
                </IonItem>
              ))}
            </IonRadioGroup>
          </IonList>
          <Button title={t('save_changes')} className="px-md" onClick={onSaveClick} />
        </section>
      </ModalWrapper>
    </>
  );
};

export default LanguageSwitcherModal;
